// const KEY = 'userInfo'

// 存储本地token
export function setLocalStorage(key, data) {
    localStorage.setItem(key, JSON.stringify(data))
}

// 获取本地
export function getLocalStorage(key) {
    return JSON.parse(localStorage.getItem(key))
}

// 删除本地
export function removeLocalStorage(key) {
    localStorage.removeItem(key)
}

// 存储内存
export function setSessionStorage(key, data) {
    sessionStorage.setItem(key, JSON.stringify(data))
}

// 获取内存
export function getSessionStorage(key) {
    return JSON.parse(sessionStorage.getItem(key))
}

// 删除内存
export function removeSessionStorage(key) {
    sessionStorage.removeItem(key)
}